import React from "react";
import {SvgIcon} from "@mui/material";

const inRange = value => {
    if(value < 255) {
        return value < 1 ? 0 : value
    } else {
        return 255
    }
}

const lightenDarkenColor = (color, percent) => {
    const num = parseInt(color.replace("#",""),16)
    const amt = Math.round(2.55 * percent)
    const R = inRange((num >> 16) + amt)
    const B = inRange((num >> 8 & 0x00FF) + amt)
    const G = inRange((num & 0x0000FF) + amt)
    return "#" + (0x1000000 + R*0x10000 + B*0x100 + G).toString(16).slice(1);

}

export const AppIcon = ({appNameAbbreviation, color="#EB314E", size=32}) => {
    const darkenPercent=10
    const fontColor = lightenDarkenColor(color, -darkenPercent)

    return (
        <SvgIcon
            sx={{
                width: `${size}px`,
                minWidth: `${size}px`,
                height: `${size}px`,
            }}
        >
            <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 64 64"
                height="128"
                width="128"
                dominantBaseline={"middle"}
                role={"graphics-document"}
            >
                <defs>
                    <style>
                        @import url("https://fonts.googleapis.com/css?family=Roboto:700");
                    </style>
                </defs>

                <path
                    fill="#000"
                    fillOpacity=".08"
                    d="M10 57.75H6L6.00004 62H44.96C49.6516 62 51.9974 62 53.887 61.353C57.3957 60.1517 60.1518 57.3957 61.3531 53.887C62 51.9973 62 49.6516 62 44.96V6H58.75V48.75L57 55.25L51.5 57.75H10Z"
                />
                <path
                    fill={color}
                    fillRule="evenodd"
                    d="M4.64698 12.113C4 14.0027 4 16.3484 4 21.04V60H42.96C47.6516 60 49.9973 60 51.887 59.353C55.3957 58.1517 58.1517 55.3957 59.353 51.887C60 49.9973 60 47.6516 60 42.96V4H21.04C16.3484 4 14.0027 4 12.113 4.64698C8.60434 5.84826 5.84826 8.60434 4.64698 12.113Z"
                    clipRule="evenodd"
                />
                <path
                    fill="#fff"
                    fillRule="evenodd"
                    d="M56 8H21.04C16.0207 8 14.5097 8.05436 13.4087 8.43132C11.0696 9.23217 9.23217 11.0696 8.43132 13.4087C8.05436 14.5097 8 16.0207 8 21.04V56H42.96C47.9793 56 49.4903 55.9456 50.5913 55.5687C52.9304 54.7678 54.7678 52.9304 55.5687 50.5913C55.9456 49.4903 56 47.9793 56 42.96V8Z"
                    clipRule="evenodd"/>
                <text
                    className="text"
                    strokeWidth="0"
                    textAnchor="middle"
                    x="49.25%"
                    y="53%"
                    fill={fontColor}
                    fontSize={2 < appNameAbbreviation.length ? "20px" : "28px"}
                    fontFamily="Roboto"
                    fontWeight={"700"}
                    letterSpacing="-0.035em"
                >
                    {appNameAbbreviation}
                </text>
            </svg>
        </SvgIcon>
    )
}
